'use client';

import { CardButton, cardButtonTag } from '@ni/nimble-components/dist/esm/card-button';
import { wrap } from '../utilities/react-wrapper';

export { cardButtonTag };
export { type CardButton };
export const NimbleCardButton = wrap(CardButton);
